<template>
  <div class="d-flex flex-column gap-3">
    <div v-for="(grupoDeListas) in grupos" :key="grupoDeListas.IdGrupoDeListas" class="m-0 fs-7 w-100">
      <div class="d-flex flex-column gap-1 fondo-terciario sombra-sm rounded-4">
        <div class="fondo-terciario sombra-sm p-2 px-3 rounded-4">
          <p class="m-0 fs-5">{{ grupoDeListas.Nombre }}</p>
        </div>
        <div v-for="(listas, indexLista) in grupoDeListas.Listas" :key="listas.IdLista" class="d-flex flex-row justify-content-between gap-1 ms-2 p-2 px-3">
          <div class="d-flex flex-column gap-1 justify-content-center">
            <p class="m-0"><strong>{{ indexLista + 1 }}. </strong>{{ listas.Nombre }}</p>
            <p v-if="listas.PersonaResponsable" class="m-0 ms-2"><strong>{{ $t('responsable') }}: </strong>{{ listas.PersonaResponsable.Nombre }} {{ listas.PersonaResponsable.Apellido }}</p>
          </div>
          <div v-if="listas.loadingDeleteLista" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
            <img src="@/assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
          </div>
          <button v-if="hasEditarListasPermission" type="button" class="btn p-1 d-flex flex-row align-items-center justify-content-center tooltip-container border-0" @click="unAssignLista(listas)">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal">
              <path d="M10 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M14 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="tooltip-text">{{ $t('eliminar') }}</span>
          </button>
        </div>
      </div>
    </div>
    <p v-if="!grupos || grupos.length == 0" class="m-0 fs-5 text-center">{{ $t('noEstaEnNingunaLista') }}</p>

    <form v-if="hasEditarListasPermission && addingLista" @submit.prevent class="d-flex flex-row align-items-center gap-2">
      <div class="position-relative w-100 d-flex flex-row">
        <input type="text" v-model="searchQuery" :placeholder="$t('buscarLista')+'...'" class="form-control w-100 sombra-sm" @input="filterLista" required/>
        <ul v-if="filteredLista.length > 0" class="list-group position-absolute sombra-sm" style="z-index: 1000; width: 100%; top: 100%; max-height: 200px; overflow-y: auto;">
          <li v-for="lista in filteredLista" :key="lista.IdLista" class="list-group-item list-group-item-action d-flex flex-column" @click="selectLista(lista)" style="cursor: pointer;">
            <span class="fs-7">{{ lista.Nombre }}</span>
          </li>
        </ul>

        <div v-if="loadingListas" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
          <img src="@/assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
        </div>
      </div>
      <button type="button" class="btn success-btn sombra-sm" @click="saveAssignLista()">
        {{ $t('agregar') }}
      </button>
      <button type="button" class="btn secondary-btn sombra-sm" @click="addingLista = false; searchQuery = ''; selectedLista = null">
        {{ $t('cancelar') }}
      </button>
    </form>
    <div v-if="hasEditarListasPermission && !addingLista" class="col card-hover-scale-sm" @click="addingLista = true">
      <div class="card rounded-4 border-0 d-flex flex-column align-items-center justify-content-center fondo-terciario sombra-sm texto-principal" style="height: 100%; cursor: pointer;">
        <div class="card-body text-center d-flex flex-column align-items-center justify-content-center" style="height: 100%;">
          <h3>+</h3>
          <p class="m-0">{{ $t('añadirNuevaGaleria') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import api from '@/services/api';

export default {
  name: 'ListasSection',
  props: {
    persona: {
      type: Object,
      required: true
    },
    hasEditarListasPermission: {
      type: Boolean,
      default: false
    }
  },
  emits: ['updated'],
  setup(props, { emit }) {
    const { t } = useI18n();
    const grupos = ref([]);
    const addingLista = ref(false);
    const searchQuery = ref('');
    const filteredLista = ref([]);
    const selectedLista = ref(null);
    const loadingListas = ref(false);
    const gruposDisponibles = ref([]);

    const fetchGruposDePersona = async () => {
      try {
        const response = await api.get(`api/Grupos/by-persona-relacionada/` + props.persona.IdPersona);
        grupos.value = response.data;
      } catch (error) {
        console.error('Error al obtener los grupos de la persona:', error);
      }
    };

    const fetchGrupos = async () => {
      try {
        loadingListas.value = true;
        const response = await api.get(`api/Grupos`);
        response.data.forEach(grupoDeListas => {
          grupoDeListas.Listas.forEach(lista => {
            let responsable = lista.PersonaResponsable ? ` (${lista.PersonaResponsable.Apellido}, ${lista.PersonaResponsable.Nombre})` : '';
            gruposDisponibles.value.push({
              IdLista: lista.IdLista,
              Nombre: grupoDeListas.Nombre + ' -> ' + lista.Nombre + responsable,
            });
            console.log(lista) // Agrega este console.log para verificar la estructura de cada lista
          });
        });
        console.log(gruposDisponibles.value)
        loadingListas.value = false;
      } catch (error) {
        loadingListas.value = false;
        console.error('Error al obtener los grupos:', error);
      }
    };

    const filterLista = () => {
      if (searchQuery.value === '') {
        filteredLista.value = [];
        return;
      }

      const query = searchQuery.value;
      const lowerCaseQuery = query.toLowerCase();

      const queryWords = lowerCaseQuery.split(' ').filter(word => word.length > 0);

      const exactMatches = gruposDisponibles.value.filter(lista => {
        return lista.Nombre.includes(query);
      });

      const otherMatches = gruposDisponibles.value.filter(lista => {
        const nombreLowerCase = lista.Nombre.toLowerCase();

        if (exactMatches.includes(lista)) {
          return false;
        }

        if (nombreLowerCase.includes(lowerCaseQuery)) {
          return true;
        }

        return queryWords.every(word => nombreLowerCase.includes(word));
      });

      const combinedResults = [...exactMatches, ...otherMatches];
      filteredLista.value = combinedResults;
    };

    const selectLista = (lista) => {
      selectedLista.value = lista.IdLista;
      searchQuery.value = `${lista.Nombre}`;
      filteredLista.value = [];
    };

    const saveAssignLista = async () => {
      try {
        if (!selectedLista.value) {
          alert('No se seleccionó una Lista.');
          return;
        }
        const params = {
          IdPersona: props.persona.IdPersona,
          IdLista: selectedLista.value
        };
        await api.post(`api/Grupos/listas/assign-persona`, params);
        await fetchGruposDePersona();
        emit('updated');
        addingLista.value = false;
        searchQuery.value = '';
      } catch (error) {
        console.error('Error al guardar los cambios:', error);
        addingLista.value = false;
        let errorMessage = 'Hubo un problema al guardar los datos.';
        if (error.response) {
          errorMessage = error.response.data || errorMessage + ' Por favor, inténtelo de nuevo.';
        } else if (error.request) {
          errorMessage = 'No se pudo conectar con el servidor. Verifique su conexión a internet.';
        } else {
          errorMessage = 'Error inesperado: ' + error.message;
        }
        alert(errorMessage);
      }
    };

    const unAssignLista = async (opcion) => {
      try {
        opcion.loadingDeleteLista = true;
        const params = {
          IdPersona: props.persona.IdPersona,
          IdLista: opcion.IdLista
        };
        await api.post(`api/Grupos/listas/unassign-persona`, params);
        fetchGruposDePersona();
        opcion.loadingDeleteLista = false;
        emit('updated');
      } catch (error) {
        opcion.loadingDeleteLista = false;
        console.error('Error al guardar los cambios:', error);
        let errorMessage = 'Hubo un problema al guardar los datos.';
        if (error.response) {
          errorMessage = error.response.data || errorMessage + ' Por favor, inténtelo de nuevo.';
        } else if (error.request) {
          errorMessage = 'No se pudo conectar con el servidor. Verifique su conexión a internet.';
        } else {
          errorMessage = 'Error inesperado: ' + error.message;
        }
        alert(errorMessage);
      }
    };

    onMounted(() => {
      fetchGrupos();
      if (props.persona.IdPersona) {
        fetchGruposDePersona();
      }
    });

    watch(() => props.persona.IdPersona, (newId) => {
      if (newId) {
        fetchGruposDePersona();
      }
    });

    return {
      t,
      grupos,
      addingLista,
      searchQuery,
      filteredLista,
      selectedLista,
      loadingListas,
      filterLista,
      selectLista,
      saveAssignLista,
      unAssignLista,
    };
  }
};
</script>

<style>
</style>